module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <input type="text" class="code full-width" placeholder="JavaScript code here">\n    <span class="help-block">The code is run on the embedding page when using channels.</span>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/js/JsActionPropertiesView.tpl
// module id = 1710
// module chunks = 0